import { Trans } from "@lingui/macro";
import { IApiEpBillingProductPostsPackage } from "@smp/api";
import { UiBox } from "@smp/ui";

export * from "./composition_posts_package";

export const CompositionPostsPackage = ({
  productPostsPackage,
}: {
  productPostsPackage: IApiEpBillingProductPostsPackage;
}) => (
  <UiBox display="flex" flexDirection="row">
    <UiBox flexGrow={1} pl={2}>
      <Trans>Quantity</Trans>
    </UiBox>
    <UiBox flexGrow={1} textAlign="right">
      {productPostsPackage.amount}
    </UiBox>
  </UiBox>
);
